exports.engines = {
  c: 'C',
  dotnet: 'C# / .NET',
  go: 'Go',
  java: 'Java',
  node: 'Node',
  php: 'PHP',
  python: 'Python',
  ruby: 'Ruby',
}

exports.languages = {
  c: 'c_cpp',
  dotnet: 'csharp',
  go: 'golang',
  java: 'java',
  node: 'javascript',
  php: 'php',
  python: 'python',
  ruby: 'ruby',
}

exports.themes = {
  colors: {
    blue: '#2697c0',
    brightBlue: '#1e87f0',
    grey: '#323232',
  },
}
